import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NAM_BM_SIGNUP_LIMIT_FOUNDATIONAL_EXPERIMENT_221010 } from "@faire/web-api--source/indigofair/settings/NAM_BM_SIGNUP_LIMIT_FOUNDATIONAL_EXPERIMENT_221010";

export const useSettingNamBmSignupLimit = () =>
  useSetting(NAM_BM_SIGNUP_LIMIT_FOUNDATIONAL_EXPERIMENT_221010, false);
